import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { SiteIdContainer } from "./CompanyInfo.styled";
import { DivBackgroundOpacity } from "@utils/extra-style";
import "../../SiteList.scss";

const CompanyInfo = (props) => {
  const { t, data, id, isActive } = props;

  return (
    <>
      <DivBackgroundOpacity opacity={isActive ? 1 : "0.2"}>
        <SiteIdContainer>
          <Link
            className="site-list__company-link"
            to={`/company/view/${id}/general-info`}
          >
            {data}
          </Link>
        </SiteIdContainer>
      </DivBackgroundOpacity>
    </>
  );
};

CompanyInfo.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(CompanyInfo);
